<template>
	<div class="w-full">
        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6">
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<button v-on:click="viewModal" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Add Network
				</button>
			</div>
		</div>

		<CustomTable class="bg-white rounded shadow-md group">
			<template v-slot:header>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Type</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">User Count</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Location</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
			</template>
			<template v-slot:body>
				<tr class="hover:bg-grey-lighter" v-for="network in networks" v-if="!polling">
					<td class="py-4 px-6 border-b border-grey-light">{{ network.name }}</td>
					<td class="py-4 px-6 border-b border-grey-light">{{ network.marketType | parseMarketType }}</td>
					<td class="py-4 px-6 border-b border-grey-light">users</td>
					<td class="py-4 px-6 border-b border-grey-light">{{ network.locationText }}</td>
                    <td class="py-4 px-6 border-b border-grey-light text-right">
                        <button class="px-2 py-1 rounded bg-blue-700 text-white text-xs" v-on:click="editNetworkModal(network)">
                            <i class="fa fa-edit"></i>
                        </button>
                    </td>
				</tr>
				<tr class="bg-grey-lighter text-center" v-if="polling">
					<td class="py-5" colspan="4">
						<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
					</td>
				</tr>
			</template>
		</CustomTable>

		<add-network-modal></add-network-modal>
        <edit-network-modal></edit-network-modal>
	</div>
</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
    import AddNetworkModal from '../modals/AddNetworkModal'
    import EditNetworkModal from '../modals/EditNetworkModal'
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'Networks',
		data () {
			return {
                networks: {},
                polling: true,
			}
        },
        components: {
            'add-network-modal': AddNetworkModal,
            'edit-network-modal': EditNetworkModal,
            CustomTable
		},
        mounted() {
            this.getNetworks();

            this.$nextTick(function () {
                EventBus.$on('admin-add-network-refresh-data', this.getNetworks);
            }.bind(this));
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getNetworks() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/networks", this.getAuthorizationHeader()).then((response) => {
                    _this.networks = response.data
                    _this.polling = false
                });
            },
            viewModal() {
                EventBus.$emit('admin-add-network-open-modal');
            },
            editNetworkModal(data) {
                EventBus.$emit('admin-edit-network-open-modal', data);
            }
        },
        filters: {
            parseMarketType: function(data) {
                var lower = data.toLowerCase();
                return lower.replace(/(^| )(\w)/g, function(x) {
                    return x.toUpperCase();
                });
            }
        }
	}
</script>